import { Typography } from "@mui/material";
import { BiotechOutlined } from "@mui/icons-material";
import { ServiceRequestActions } from "../../ServiceRequest/ServiceRequestAction";
import { DocumentCard } from "../../../../../../components/common/DocumentCard";
import { EhrResponsiveTable } from "../../../mobile/EhrResponsiveTable";

export function Solicitations({
  rowData = [],
  resultsData,
  handleOpen,
  setBinaryUrl,
  sign,
  setRefetch,
}: any) {
  const columns = [
    {
      column: "Descrição",
      rowName: "description",
      width: "28%",
      lineClamp: 0,
    },
    { column: "Data", rowName: "date", width: "16%" },
    { column: "Categoria", rowName: "category", width: "18%" },
    {
      column: "Profissional",
      rowName: "practitioner",
      width: "20%",
      lineClamp: 1,
    },
  ];

  return (
    <EhrResponsiveTable
      title="Solicitações de exame"
      hideSectionHeader
      columns={columns}
      rows={rowData}
      actions={(row: any) => (
        <ServiceRequestActions
          setRefetch={setRefetch}
          row={row}
          handleOpen={handleOpen}
          setBinaryUrl={setBinaryUrl}
        />
      )}
      renderCard={(row) => (
        <DocumentCard
          key={row.id ?? row.description}
          title={row.description || "Solicitação de Exame"}
          date={row.date}
          practitioner={row.practitioner}
          specialty={row.specialty}
          status={{
            text: row.category,
            color: "#2196F3",
            icon: <BiotechOutlined fontSize="small" />,
          }}
          actions={
            <ServiceRequestActions
              setRefetch={setRefetch}
              row={row}
              handleOpen={handleOpen}
              setBinaryUrl={setBinaryUrl}
            />
          }
        >
          {row.resultUrls && row.resultUrls.length > 0 ? (
            <Typography variant="body2" color="success.main" sx={{ mt: 1 }}>
              {row.resultUrls.length > 1
                ? `${row.resultUrls.length} resultados disponíveis`
                : "Resultado disponível"}
            </Typography>
          ) : null}
        </DocumentCard>
      )}
    />
  );
}
